import Conclusion from "./OurApproach/Conclusion";
import DC from "./OurApproach/DC";
import FocusScope from "./OurApproach/FocusScope";
import Geographic from "./OurApproach/Geographic";
import Hero from "./OurApproach/Hero";
import Maryland from "./OurApproach/maryland";
import SituationAnalysis from "./OurApproach/SituationAnalysis";
import Virginia from "./OurApproach/virginia";
import SEO from "./SEO";
import React from "react";
import { useEffect } from "react";
import ReactGA  from "react-ga4";
const OurApproach = () => {
	useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/",
      title: "Landing Page",
    });
  });
	return (
		<div className="md:text-lg/8 text-base/6">
			<SEO
				title='Our Approach | SynergyCare Foundation '
				description='See how SynergyCare Foundation is approaching taking  healthcare to under-served populations.'
				name='SynergyCare Foundation'
				type=''
			/>
			<Hero />
			<SituationAnalysis />
			<Maryland />
			<Virginia />
			<DC />
			<FocusScope />
			<Geographic/>
			<Conclusion/>
		</div>
	);
};

export default OurApproach;